module.exports = __webpack_public_path__ + "blood-and-its-components.27a9a8950bab1bff408375688d04a057.png";